import {
  Box,
  Button,
  Fade,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { X, CircleAlert } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  AnimatedContainer,
  RootContainer,
} from "@components/ChatAgent/components/ChatAgentErrorOverlay/style";

interface ChatAgentErrorOverlayProps {
  error: string;
  onReset: () => void;
  onClose: () => void;
}

const ChatAgentErrorOverlay = ({
  error,
  onReset,
  onClose,
}: ChatAgentErrorOverlayProps) => {
  const { t } = useTranslation("agent_chat");

  return (
    <AnimatedContainer in>
      <RootContainer gap={"20px"}>
        <X size={24} onClick={onClose} style={{ cursor: "pointer" }} />
        <CircleAlert size={50} />
        <Stack alignItems="center">
          <Typography sx={{ fontWeight: "bold", textAlign: "center" }}>
            {t("session_error")}
          </Typography>
          {error && (
            <Typography sx={{ fontSize: "10px", textAlign: "center" }}>
              {error}
            </Typography>
          )}
        </Stack>
        <Stack spacing={1}>
          <Button variant={"contained"} onClick={onReset}>
            {t("restart_session_btn")}
          </Button>
        </Stack>
      </RootContainer>
    </AnimatedContainer>
  );
};

export default ChatAgentErrorOverlay;
